module.exports = __webpack_public_path__ + "static/media/friends-card.ffc4409f.png";